import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import resourcesApi from '../../utils/resourcesApi';
import ResourceCard from './ResourceCard';
import LoadingScreen from '../LoadingScreen';

/**
 * RecentResourcesSection component - Displays the 3 most recent resources
 * Used on the homepage to highlight new content
 */
const RecentResourcesSection = () => {
  const [loading, setLoading] = useState(true);
  const [resources, setResources] = useState([]);

  useEffect(() => {
    const fetchRecentResources = async () => {
      try {
        setLoading(true);
        const recentResources = await resourcesApi.getRecentResources(3);
        setResources(recentResources);
      } catch (error) {
        console.error('Error fetching recent resources:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchRecentResources();
  }, []);

  if (loading) {
    return <LoadingScreen message="Loading recent resources..." />;
  }

  // Don't render if no resources
  if (!resources || resources.length === 0) {
    return null;
  }

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-block mb-4">
            <div className="w-16 h-1 bg-primary-500 rounded mb-1 mx-auto"></div>
            <div className="w-10 h-1 bg-primary-500 rounded mx-auto"></div>
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Latest Resources</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Stay informed with our most recent publications and insights
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {resources.map(resource => (
            <div key={resource.id} className="transform transition-all duration-300 hover:-translate-y-2">
              <ResourceCard resource={resource} />
            </div>
          ))}
        </div>
        
        <div className="text-center mt-10">
          <Link 
            to="/resources" 
            className="inline-flex items-center px-6 py-3 border border-primary-500 text-base font-medium rounded-md text-primary-700 bg-white hover:bg-primary-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transition-colors duration-300"
          >
            View All Resources
            <svg 
              className="ml-2 -mr-1 h-5 w-5" 
              xmlns="http://www.w3.org/2000/svg" 
              viewBox="0 0 20 20" 
              fill="currentColor"
            >
              <path 
                fillRule="evenodd" 
                d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" 
                clipRule="evenodd" 
              />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default RecentResourcesSection; 